import { Icon, Button, Pill } from '@iwoca/orion';

import OfferCard from '../OfferCard';

const Flexi12OfferCard = ({
    amount,
    onSelect,
    isPartnerCustomer,
    showProbabilityOfOffer,
    offerType,
    noDocRequirements
}: {
    amount: string;
    onSelect: () => void;
    isPartnerCustomer: boolean;
    showProbabilityOfOffer: boolean;
    offerType: string;
    noDocRequirements?: boolean;
}) => {
    return (
        <OfferCard
            testID="flexi-12-manual-offer-card"
            pills={
                <>
                    <Pill variant="london">Eligible</Pill>
                    {isPartnerCustomer && showProbabilityOfOffer && (
                        <Pill variant="green">High chance of approval</Pill>
                    )}
                </>
            }
            title={
                isPartnerCustomer ? (
                    <h3>Flexi loan</h3>
                ) : (
                    <h3>Repay over one year or less</h3>
                )
            }
            features={
                <ul>
                    <li>
                        <Icon icon="clockOutline" /> Decision in 24 hours
                    </li>
                    <li>
                        <Icon icon="calendarOutline" /> Borrow from 1 day to 12
                        months
                    </li>
                    {!noDocRequirements && (
                        <li>
                            <Icon icon="fileWithItemsOutline" /> Documents
                            required
                        </li>
                    )}
                </ul>
            }
            details={
                <ul>
                    {offerType === 'confirmed' ? (
                        <li>
                            Confirmed amount <span>{amount}</span>
                        </li>
                    ) : (
                        <li>
                            Estimated amount <span>{amount}</span>
                        </li>
                    )}

                    {/* This is disabled currently, as APR needs to be shown alongside monthly interest
                  for indicative/sample offers, &  is not currently available */}
                    {/* <li>
                      Monthly interest <span>{interestRate}%</span>
                  </li> */}
                </ul>
            }
            button={
                <Button variant="secondary" onClick={onSelect}>
                    {noDocRequirements ? 'Select offer' : 'Upload documents'}
                </Button>
            }
            footer={
                <p>
                    Once you've provided the key documents, we'll give you our
                    decision within 1 business day. This won't affect your
                    credit score. The loan amount might change depending on what
                    you tell us - and we can't guarantee you'll be approved.
                </p>
            }
        />
    );
};

export default Flexi12OfferCard;
